﻿import { defineStore } from 'pinia';

import authDefaults from '@/auth/defaults';
import { getStorage } from './index';

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            accessToken: null,
            userInfo: null
        };
    },

    getters: {
        isAuthenticated: (state) => state.accessToken != null,

        hasLocalAccount() {
            return this.isAuthenticated && this.userInfo && this.userInfo.has_local_account;
        },

        isLoggedInAsAnotherUser() {
            return this.isAuthenticated && this.userInfo && this.userInfo.admin_username;
        }
    },

    actions: {
        isInRole(roles) {
            if (!this.userInfo)
                return false;

            let rolesToMatch = typeof (roles) === 'string' ? [roles] : roles;

            return this.userInfo.role.some((r) => rolesToMatch.includes(r));
        },

        reset() {
            this.$patch({
                accessToken: null,
                userInfo: null
            });
        }
    },

    persist: {
        storage: getStorage(authDefaults.tokenStorageType)
    }
});